import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ab6bfa6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ab6bfa6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6bfa6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab6bfa6c')) {
      api.createRecord('ab6bfa6c', component.options)
    } else {
      api.reload('ab6bfa6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ab6bfa6c&scoped=true", function () {
      api.rerender('ab6bfa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/rewardList/index.vue"
export default component.exports